<template>
  <div class="home">
    <iframe
      src="https://player.twitch.tv/?channel=didi_sharktank&parent=localhost&parent=didi-shark-tank.firebaseapp.com&parent=www.didi-shark-tank.firebaseapp.com&parent=colombia.didiglobal.com&parent=www.colombia.didiglobal.com"
      frameborder="0"
      allowfullscreen="true"
      class="video"
      v-if="stream"
    >
    </iframe>
    <form class="form-comentario" @submit.prevent="onSubmit" v-if="stream">
      <div>
        <input
          type="text"
          placeholder="Escribe tu pregunta acá..."
          v-model="comentario"
        />
        <!-- <textarea cols="30" rows="3" placeholder="Escribe tu comentario acá"></textarea> -->
      </div>
    </form>
    <VueSlickCarousel
      :dots="true"
      class="home__carousel"
      :autoplay="true"
      :autoplaySpeed="5000"
      :arrows="false"
    >
      <div class="home__hero home__hero--1">
        <div class="left">
          <h1>
            Shark Tank Colombia <br />
            presenta DiDi Lab. <br />
            <span> Laboratorio de ideas para la reactivación del país.</span>
          </h1>
        </div>
        <div></div>
      </div>
      <div class="home__hero home__hero--2">
        <div class="left"></div>
        <div></div>
      </div>
      <div class="home__hero home__hero--3">
        <div class="left"></div>
        <div></div>
      </div>
    </VueSlickCarousel>

    <!-- <section class="home__section-1">
      <div class="left">
        <h4>
          DiDi y Sony Channel se unen para apoyar la reactivación del país.
        </h4>
        <p>
          Esta es una oportunidad para que las mentes creativas e innovadoras de
          Bogotá, Colombia, que tienen ideas y emprendimientos con impacto
          económico y social, puedan participar en un concurso en el que
          pondremos a prueba su capacidad innovadora en diferentes pruebas
          frente a nuestro panel de jurado. Disfruta de este contenido en el
          canal de YouTube de Shark Tank Colombia.
        </p>
        <router-link to="/concurso" class="btn-concurso"
          >Conoce más del concurso</router-link
        >
      </div>
      <div></div>
    </section> -->

    <section class="home__section-2">
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/a1844rQ3MWQ"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </section>

    <section class="home__section-3"></section>

    <section class="home__section-4">
      <div class="left">
        <h2>
          DiDi Lab <br />
          <span>Laboratorio de ideas para la reactivación del país.</span>
        </h2>
      </div>
      <div class="right">
        <p>
          En DiDi nuestro compromiso con la comunidad y el país lo manifestamos
          por medio de iniciativas y proyectos tangibles que contribuyan a la
          sociedad a la que servimos.
        </p>
        <p>
          Por eso, bajo nuestra sombrilla de Responsabilidad Social: DiDi Apoyo,
          desarrollamos DiDi Lab en alianza con Sony Channel y el apoyo de la
          Universidad de los Andes, para crear un laboratorio de ideas que
          contribuya a la reactivación de Colombia.
        </p>
      </div>
    </section>

    <Allies />
  </div>
</template>

<script>
// @ is an alias to /src
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import Allies from "@/components/Allies";
import Swal from "sweetalert2";
import { db } from "../firebase";
export default {
  components: { VueSlickCarousel, Allies },
  data() {
    return {
      comentario: "",
      stream: false,
    };
  },
  async mounted() {
    await db.collection("stats").doc("stats").onSnapshot(this.manejarSnapshot);
  },
  methods: {
    onSubmit() {
      Swal.fire(
        "Enviado",
        "Tu comentario ha sido enviado correctamente",
        "success"
      );
      this.comentario = "";
    },

    manejarSnapshot(snapshot) {
      this.stream = snapshot.data().stream;
    },
  },
};
</script>

<style lang="scss">
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url("../assets/images/bg.jpg") no-repeat;
  background-size: cover;

  .video {
    width: 70%;
    height: 500px;
    margin: 3rem auto;
    display: block;
  }

  .form-comentario {
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 3rem;

    div {
      position: relative;
      background-color: white;
      border-radius: 20px;
      width: 50%;

      &::before {
        content: "";
        width: 0px;
        height: 0px;
        position: absolute;
        border-left: 10px solid transparent;
        border-right: 10px solid #ffffff;
        border-top: 10px solid #ffffff;
        border-bottom: 10px solid transparent;
        right: 19px;
        bottom: -19px;
      }
    }

    input {
      background-color: #ffffff;
      color: #736357;
      padding: 10px;
      width: 100%;
      resize: none;
      border-radius: 20px;
      position: relative;
      padding: 20px;
    }
  }

  .slick-dots {
    bottom: 10px;
  }

  .slick-dots li button::before {
    color: white;
    font-size: 12px;
  }

  &__carousel {
    width: 100%;
  }

  &__hero {
    height: 70vh;
    width: 100%;
    padding: 2rem 4rem;
    display: grid !important;

    @include phone {
      padding: 1rem 2rem;
      height: 30vh;
    }

    &--1 {
      background: url("../assets/images/home/hero_1_2.jpg") no-repeat;
      background-size: cover;
      grid-template-columns: 40% 60%;

      @include phone {
        grid-template-columns: 60% 40%;
      }
    }
    &--2 {
      background: url("../assets/images/home/hero_2_2.jpg") no-repeat;
      background-size: cover;
      grid-template-columns: 50% 50%;

      @include phone {
        grid-template-columns: 80% 20%;
      }
    }
    &--3 {
      background: url("../assets/images/home/hero_3_2.jpg") no-repeat;
      background-size: cover;
      grid-template-columns: 60% 40%;

      @include phone {
        grid-template-columns: 80% 20%;
      }
    }

    .left {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      h1 {
        color: white;

        @include phone {
          font-size: 0.8rem;
          width: 100%;
        }

        span {
          font-weight: 100;
        }
      }
    }
  }

  &__section-1 {
    margin: 4rem 0;
    width: 80%;
    background: url("../assets/images/home/section_1.jpg") 50% 50% no-repeat;
    background-size: cover;
    display: grid;
    grid-template-columns: 40% 60%;
    padding: 6rem 4rem 4rem;

    @include phone {
      padding: 1rem;
      margin: 2rem 0;
      grid-template-columns: 90% 10%;
    }

    .left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      color: white;
      h4 {
        font-size: 1.5rem;
      }
      p {
        margin: 0.5rem 0 2rem 0;
      }

      .btn-concurso {
        cursor: pointer;
        background: $main-color;
        color: white;
        font-family: "Montserrat", sans-serif;
        border-radius: 50px;
        padding: 0.6rem 2.5rem;
        text-decoration: none;
        font-weight: bold;

        @include phone {
          padding: 0.7rem;
        }
      }
    }
  }

  &__section-2 {
    display: flex;
    flex-direction: column;
    align-items: center;

    h2 {
      color: white;
      text-transform: uppercase;
    }
    iframe {
      margin: 2rem 0 4rem 0;
      @include phone {
        width: 100%;
        margin: 2rem auto;
      }
    }
  }

  &__section-4 {
    margin: 2rem 0 8rem 0;
    width: 65%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 4rem;
    align-items: center;

    @include phone {
      display: flex;
      flex-direction: column;
      width: 90%;
      margin: 4rem auto;
    }

    .left {
      color: $main-color;
      padding: 0 4rem;

      @include phone {
        padding: 0;
        margin-bottom: 1rem;
      }

      h2 {
        font-size: 2rem;
        line-height: 0.65em;
        span {
          font-size: 1.25rem;
        }
      }
    }

    .right {
      color: white;
      p {
        font-family: "Montserrat", sans-serif;
      }
      p:first-child {
        margin-bottom: 2rem;
      }
    }
  }
}
</style>
